const Theme = {
body_background_color: '#1f1e45',
// header_background_color: '#0000ab',

  title_font: 'Montserrat',
  text_font: 'Montserrat',

  logo_image_url: 'lotoquebec1AltIcon.png',
  logo_height: 180,
  header_no_border: true,

  token_hidden: true,
  title_margin: '10px',

  button_color: '#001dcf',
  button_radius: 1,
  button_border_width: 2,
}

export default Theme
// https://app.clickup.com/t/86dwnf9tw